const messages = {
    availPoints: "Dostupni bodovi",
    awaitingPoints: "Bodovi na čekanju",
  board: {
    title: "Kontrolna tabla",
    title2: "Animacija performansi {year}",
    headline1: "Vaše promocije i bodovi na prvi pogled",
    headline2: "Zaradite bodove za kupovinu guma.",
    pointsBalanceToDate: "STANJE BODOVA NA DAN",
    availPoints: "Dostupni bodovi",
    awaitingPoints: "Bodovi na čekanju",
    yourRealisation: "VAŠA POSTIGNUĆA",
    yourEngagement: "Vaša godišnja obaveza: <b>{tyres} guma</b>",
    yourPoints: "VAŠI BODOVI",
    yourRetailPurchase: "VAŠE MALOPRODAJNE KUPOVINE",
    yourRetailPurchaseCCS: "VAŠA MALOPRODAJA",
    pointsByPurchase: "bodovi generirani vašim kupovinama",
    pointsByBoosters: "bodovi koje generišu boosteri",
    pointsByBSPurchase: "Bodovi generirani vašim Bridgestone kupovinama",
    pointsByBSPurchaseCCS:
      "Bodovi generirani vašom prodajom guma Bridgestone",
    remaining: "Preostale gume",
    yourGoal: "Napredak cilja",
    unit: "gume",
    buttons: {
      learnMore: "Saznajte više o svojim bodovima",
      learnMoreAboutMechanism: "Saznajte više o mehanizmu",
    },
    charts: {
      byBrand: "Po marki",
      bySize: "Prema veličini<br/>felne",
    },
    exploreResults: "Otkrijte svoje rezultate",
    tyreLimitInfo:
      "Minimalna količina rasprodaje od 50 Bridgestone i/ili Firestone guma je potrebna za svaki period Booster kampanje",
  },
  charts: {
    byBrand: "Po marki",
    bySize: "prema veličini felne",
  },

  dashboard: {
    dashboardTitle: "Vaše pogodnosti",
    dashboardBox: {
      title: "Stanje bodova",
      description: "Vaš trenutni ukupan broj marketinških bodova",
      availPoints: "Dostupni bodovi",
      awaitingPoints: "Bodovi na čekanju",
      lastUpdate: "Posljednje ažuriranje",
      button: "Saznajte više",
      points: "bodovi",
    },
  },
  soldTyres: "PRODANE GUME",
  receivedPoints: "OSVOJENI BODOVI",
  boosterCCS: {
    personalInfo: "Lični podaci",
    csNumberTitle: "Navedite broj(eve) računa koji učestvuju",
    tyresTitle: "Molimo navedite broj prodatih guma",
    minTyresInfo:
      "Potrebno je najmanje {tyres} Bridgestone/Firestone guma. Nadoknada se odnosi samo na Bridgestone gume.",
    tyresAmount: "br. guma",
    filesTitle: "Molimo otpremite dokaz o prodaji",
    filesDescription:
      "Napomena: u obzir će se uzeti samo prodaje u kojima je navedena veličina felne gume.",
    addAnotherFile: "Dodajte drugi dokument",
    file: "Otpremite dokument",
    formatInfo:
      "Prihvaćeni formati datoteka: xlsx, jpeg i pdf. Maksimalna veličina datoteke: 8 MB",
    confrimationMessage:
      "<b>Hvala vam na učešću!</b> <br/>Vaš zahtjev je primljen i proslijeđen Bridgestone timovima na provjeru.<br/>Primit ćete obavještenje e-poštom s rezultatima vašeg učešća u Booster CCS.<br/>Vidimo se uskoro na Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Podijelite bodove",
    forShare: "Bodovi koje ćete podijeliti",
    title: "Naslov",
  },
  notFoundFile: "Ništa odabrano",
  chooseFile: "Odaberite datoteku",
};
export default {
  messages,
};
